module.exports = __webpack_public_path__ + "media/form-type-page/cogs-d88a87f8.svg";